import {
  USER_LOGIN,
  USER_LOGOUT,
  USER_LOADING,
  USER_LOADED,
  USER_REGISTERING,
  USER_REGISTERED,
  USER_VERIFYING,
  USER_VERIFIED,
} from '../constants/ActionTypes';

const initialState = {
  loading: false,
  loggedIn: false,
  registering: false,
  registered: false,
  verifying: false,
  verified: false,
  email: '',
  groups: [],
  sub: '',
  idToken: '',
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case USER_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case USER_REGISTERING:
      return {
        ...state,
        registering: action.registering,
      };
    case USER_REGISTERED:
      return {
        ...state,
        loading: false,
        loggedIn: true,
        registered: action.registered,
      };
    case USER_VERIFYING:
      return {
        ...state,
        verifying: action.verifying,
      };
    case USER_VERIFIED:
      return {
        ...state,
        loading: false,
        loggedIn: true,
        verified: action.verified,
      };
    case USER_LOADED:
      return {
        ...state,
        ...action.userInfo,
      };
    case USER_LOGIN:
      return {
        ...state,
        loading: false,
        loggedIn: true,
      };
    case USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js